import React, { useEffect } from "react";
import { renderStrapiContent } from "../utils/contentfulOptions";
import FullPageLoader from "../components/FullPageLoader";
import StrapiImage from "../components/StrapiImage";
import CornerDragonfly from "../images/corner/corner-dragonfly.webp";

const ToursTastings = (props) => {
  useEffect(() => {
    document.title = "Auburn Road - Tours & Guided Tastings";
    return () => {
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  if (!props.info) {
    return <FullPageLoader />;
  }

  const pageContent = props.info.content;
  const images = props.info.image || [];

  return (
    <>
      <img className="corner-dragonfly" src={CornerDragonfly} alt="" />
      <div className="container content-page p-t-100">
        <section className="content-hero">
          <p className="content-hero__kicker">Visit the vineyard</p>
          <h1 className="huge-text-no-quote content-hero__title">
            Tours and Tastings
          </h1>
          <p className="content-hero__intro">
            Walk the vines, taste through the cellar, and learn the story behind
            every bottle with our guided experiences.
          </p>
        </section>

        <section className="content-story">
          {images.length > 0 && (
            <div className="content-story__media">
              {images.map((image, index) => (
                <img
                  key={image.id || index}
                  className="content-story__photo"
                  src={StrapiImage(image)}
                  alt={image.alternativeText || image.Title || ""}
                />
              ))}
            </div>
          )}
          <div className="content-story__copy">
            {renderStrapiContent(pageContent)}
          </div>
        </section>
      </div>
    </>
  );
};

export default ToursTastings;
